module.exports = __webpack_public_path__ + "img/banner_bodymilk_pouch.8c7700db.jpg";